import { dismissOverlay, showOverlay } from "./actions";
import Container from "./Container";
import Reducer from "./reducer";
const componentRegistry = new Map();
function registerOverlayComponent(id, component) {
    componentRegistry.set(id, component);
}
function getOverlayComponent(id) {
    return componentRegistry.get(id);
}
export { getOverlayComponent };
function init(context) {
    const onClose = (id) => {
        const state = context.api.getState();
        const overlayInfo = state.session.overlays.overlays[id];
        context.api.store.dispatch(dismissOverlay(id));
        context.api.events.emit("did-dismiss-overlay", id, overlayInfo.options?.id);
    };
    // bit of a hack, we're not actually rendering a dialog, the overlays are added via portal, we
    // just need any node that gets rendered
    context.registerOverlay("overlay", Container, () => ({
        onClose,
    }));
    context.registerReducer(["session", "overlays"], Reducer);
    context.registerAPI("showOverlay", (id, title, content, pos = undefined, options) => {
        // If content is a React component, register it and use an identifier
        if (typeof content === "function") {
            const componentId = `component-${id}-${Date.now()}`;
            registerOverlayComponent(componentId, content);
            context.api.store.dispatch(showOverlay(id, title, undefined, componentId, pos, options));
        }
        else {
            context.api.store.dispatch(showOverlay(id, title, content, undefined, pos, options));
        }
    }, { minArguments: 3 });
    context.registerAPI("dismissOverlay", (id) => {
        onClose(id);
    }, { minArguments: 1 });
    // Expose component registry functions to extensions that need them - not sure if there's a point to this
    //  but it's easy enough to do.
    context.registerAPI("registerOverlayComponent", registerOverlayComponent, {
        minArguments: 2,
    });
    context.registerAPI("getOverlayComponent", getOverlayComponent, {
        minArguments: 1,
    });
    return true;
}
export default init;
